import { Checkbox, Modal } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Apis from '../../../../api';
import { RootState } from '../../../../store/rootReducer';
import HSButton from '../../../common/Button';
import LoginActions from '../../../login/redux/actions';
import { InvestorStatus } from '../../../login/utils/Status';
import MessageActions from '../../../message/redux/actions';

type Props = {
    isDisable: boolean;
    // className?: string;
    onSubmitCallback?: (f: boolean) => void;
    kycInfo?: any;
    myinfo?: boolean;
    setFormFields?: (f: any) => void;
};

const KYCSubmitModal: React.FC<Props> = ({
    isDisable,
    // className,
    onSubmitCallback,
    kycInfo,
    myinfo,
    setFormFields,
}) => {
    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);
    const [loader, setLoader] = useState(false);
    const [resubmissionCheck, setResubmissionCheck] = useState(false);
    const investorUUID = useSelector((state: RootState) => state.user.uuid);
    const investorType = useSelector((state: RootState) => state.user.investor?.investorType);
    const kyc = useSelector((state: RootState) => state.user.investor?.kyc);
    const investorStatus = useSelector((state: RootState) => state.user.investor?.status?.kyc);
    const currentDate = new Date();

    // useEffect(() => {
    //     if (kyc && kyc?.info && kyc?.info.type === 'Myinfo') {
    //         setResubmissionCheck(true);
    //     }
    // }, [kyc]);

    const onClickCancel = () => {
        setOpen(false);
    };

    const saveIndividualKYC = () => {
        if (investorUUID && kycInfo) {
            setLoader(true);
            onClickCancel();
            Apis.saveKYC(investorUUID, {
                legalFirstName: kycInfo.legalFirstName,
                legalLastName: kycInfo.legalLastName,
                dob: kycInfo.dob,
                identity: {
                    identityType: kycInfo.idType,
                    identityNumber: kycInfo.idNumber,
                },
                address: {
                    address1: kycInfo.address,
                    address2: kycInfo.address2,
                    postalCode: kycInfo.zipCode,
                    country: kycInfo.country,
                },
                residentialStatus: kycInfo.residentialStatus,
                nationality: kycInfo.nationality,
            })
                .then((res) => {
                    if (res.data && res.data.kyc) {
                        dispatch(LoginActions.updateKYCInfo(res.data.kyc));
                        // dispatch(MessageActions.showMessage({ text: 'KYC info updated successfully!', error: false }));
                        onSubmit();
                    }
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ text: String(err), error: true }));
                    setLoader(false);
                });
        }
    };

    const saveInstitutionalKYC = () => {
        if (investorUUID && kycInfo) {
            setLoader(true);
            onClickCancel();
            Apis.saveKYC(investorUUID, {
                legalName: kycInfo.entityName,
                identity: {
                    identityType: 'Company Registration Number',
                    identityNumber: kycInfo.registerNumber,
                },
                address: {
                    address1: kycInfo.address,
                    address2: kycInfo.address2,
                    postalCode: kycInfo.zipCode,
                    country: kycInfo.country,
                },
            })
                .then((res) => {
                    if (res.data && res.data.kyc) {
                        dispatch(LoginActions.updateKYCInfo(res.data.kyc));
                        // dispatch(MessageActions.showMessage({ text: 'KYC info updated successfully!', error: false }));
                        onSubmit();
                    }
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ text: String(err), error: true }));
                    setLoader(false);
                });
        }
    };

    const onSubmit = () => {
        if (investorUUID) {
            setLoader(true);
            onClickCancel();
            Apis.KYCSubmitReq(investorUUID, {
                action: investorStatus === InvestorStatus.PendingKYCResubmission ? 'Resubmit' : 'Submit',
            })
                .then(({ data }) => {
                    if (onSubmitCallback) {
                        onSubmitCallback(true);
                    }
                    dispatch(LoginActions.updateInvestorInfo(data));
                    // dispatch(
                    //     MessageActions.showMessage({
                    //         error: false,
                    //         text: 'KYC has been submitted successfully. Our Team will review and follow-up with you',
                    //     }),
                    // );
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                })
                .finally(() => {
                    setLoader(false);
                });
        }
    };

    const OnClickSubmit = () => {
        if (myinfo) {
            if (kyc?.info?.noa?.amount) {
                onSubmit();
            } else if (isDisable) {
                setOpen(true);
            } else {
                onSubmit();
            }
        } else {
            let name = 'isValidate';
            if (investorType === 'Individual Accredited' && setFormFields) {
                if (
                    !kycInfo.address ||
                    kycInfo.address.trim() === '' ||
                    !kycInfo.country ||
                    kycInfo.country.trim() === '' ||
                    !kycInfo.idNumber ||
                    kycInfo.idNumber.trim() === '' ||
                    !kycInfo.idType ||
                    kycInfo.idType.trim() === '' ||
                    !kycInfo.legalFirstName ||
                    kycInfo.legalFirstName.trim() === '' ||
                    !kycInfo.legalLastName ||
                    kycInfo.legalLastName.trim() === '' ||
                    !kycInfo.zipCode ||
                    kycInfo.zipCode.trim() === '' ||
                    !kycInfo.nationality ||
                    kycInfo.nationality.trim() === '' ||
                    !kycInfo.dob ||
                    kycInfo.dob.trim() === ''
                ) {
                    setFormFields({ ...kycInfo, [name]: true });
                    return;
                }
                setFormFields({ ...kycInfo, [name]: false });
            } else if ((investorType === 'Institutional' || investorType === 'Corporate Accredited') && setFormFields) {
                if (
                    !kycInfo.entityName ||
                    kycInfo.entityName.trim() === '' ||
                    !kycInfo.registerNumber ||
                    kycInfo.registerNumber.trim() === '' ||
                    !kycInfo.address ||
                    kycInfo.address.trim() === '' ||
                    !kycInfo.country ||
                    kycInfo.country.trim() === '' ||
                    !kycInfo.zipCode ||
                    kycInfo.zipCode.trim() === ''
                ) {
                    setFormFields({ ...kycInfo, [name]: true });
                    return;
                }
                setFormFields({ ...kycInfo, [name]: false });
            }
            if (isDisable) {
                setOpen(true);
            } else {
                if (investorType === 'Individual Accredited') {
                    saveIndividualKYC();
                }
                if (investorType === 'Institutional' || investorType === 'Corporate Accredited') {
                    saveInstitutionalKYC();
                }
            }
        }
    };

    return (
        <>
            {investorStatus === InvestorStatus.PendingKYCResubmission && (
                <div className="w-full">
                    <Checkbox
                        //disabled={kyc?.info.type === 'Myinfo'}
                        checked={resubmissionCheck}
                        onChange={(e) => setResubmissionCheck(e.target.checked)}
                        name="isCheck"
                    />
                    <span className="pl-4">{`I have reviewed this information and find it to be accurate as of ${moment(
                        currentDate.getTime(),
                    ).format('DD/MM/YYYY')}.`}</span>
                </div>
            )}
            <div className="flex justify-center items-center my-6">
                <HSButton
                    disabled={investorStatus === InvestorStatus.PendingKYCResubmission ? !resubmissionCheck : false}
                    title={`${investorStatus === InvestorStatus.PendingKYCResubmission ? 'Resubmit' : 'Submit'} KYC`}
                    onClick={OnClickSubmit}
                    loading={loader}
                    // className={className}
                    type="primary"
                />
            </div>
            <Modal open={open} title="Submit KYC" footer={null} onCancel={onClickCancel} onOk={onClickCancel} centered>
                <p className="text-base mb-4 text-justify">
                    You have not uploaded required document(s). Do you want to proceed?
                </p>
                <p className="text-base text-justify">
                    You may proceed for now, but please note that as part of the KYC process, you will still be required
                    to provide these documents to our team at a later stage.
                </p>
                <div className="flex justify-end py-2 pt-4 ">
                    <HSButton title="No" onClick={onClickCancel} light className="mr-2" />
                    <HSButton
                        title="Yes"
                        onClick={() => {
                            if (kycInfo && investorType && !myinfo) {
                                if (investorType === 'Individual Accredited') {
                                    saveIndividualKYC();
                                }
                                if (investorType === 'Institutional' || investorType === 'Corporate Accredited') {
                                    saveInstitutionalKYC();
                                }
                            } else {
                                onSubmit();
                            }
                        }}
                    />
                </div>
            </Modal>
        </>
    );
};

export default KYCSubmitModal;
